module.exports = __webpack_public_path__ + "img/Brown.434da602.png";